/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'icon_download_done': {
    width: 14,
    height: 16,
    viewBox: '0 0 14 16',
    data: '<defs><path pid="0" d="M5 18h14v2H5v-2zm4.6-2.7L5 10.7l2-1.9 2.6 2.6L17 4l2 2-9.4 9.3z" id="svgicon_icon_download_done_a"/></defs><g transform="translate(-5 -4)" _fill="none" fill-rule="evenodd"><mask id="svgicon_icon_download_done_b" _fill="#fff"><use xlink:href="#svgicon_icon_download_done_a"/></mask><g mask="url(#svgicon_icon_download_done_b)" _fill="#898D94"><path pid="1" d="M0 0h24v24H0z"/></g></g>'
  }
})



// WEBPACK FOOTER //
// ./src/components/icons/icon_download_done.js